import { render, staticRenderFns } from "./renwuCenter.vue?vue&type=template&id=94d208f8&scoped=true"
import script from "./renwuCenter.vue?vue&type=script&lang=js"
export * from "./renwuCenter.vue?vue&type=script&lang=js"
import style0 from "./renwuCenter.vue?vue&type=style&index=0&id=94d208f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d208f8",
  null
  
)

export default component.exports